module.exports = __webpack_public_path__ + "static/media/striped_bar_shotStrip_tall.fa3c1210.svg";